import { rd } from '@passionware/monads';
import { ComponentProps } from 'react';
import {
  LanguageScope,
  Locale,
  WithLocaleService
} from 'v5/services/LocaleService/LocaleService';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '../../design-system/Select';
import { cn } from '../../platform/dom/cn';

export interface LanguageSwitcherWidgetProps {
  services: WithLocaleService;
  className?: string;
  scope?: LanguageScope;
  size?: ComponentProps<typeof SelectTrigger>['size'];
  onLanguageChange?: (locale: Locale) => void;
}

export function LanguageSwitcherWidget({
  services,
  scope = 'public',
  className,
  size = 'sm',
  onLanguageChange
}: LanguageSwitcherWidgetProps) {
  const { localeService } = services;
  const currentLocale = localeService.useCurrentLocale();
  const supportedLanguages = localeService.useSupportedLanguages(scope);
  const changeLocale = localeService.useChangeCurrentLocale();

  return (
    <Select
      value={currentLocale}
      onValueChange={value => {
        if (value) {
          changeLocale(value as Locale);
          onLanguageChange?.(value as Locale);
        }
      }}
    >
      <SelectTrigger size={size} className={cn('w-fit', className)}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent align="end">
        {supportedLanguages.map(({ locale, flag, label }) => (
          <SelectItem key={locale} value={locale} size="lg">
            <div>{flag}</div>
            <div className="group-[.is-trigger]:hidden">{label}</div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
